import { ProgressBar } from '@/components/ui/ProgressBar';
import { Tooltip } from '@/components/ui/Tooltip';
import { Zap } from 'lucide-react';

interface Props {
  used: number;
  limit: number;
}

export function ActionUsageMeter({ used, limit }: Props) {
  const pct = limit > 0 ? (used / limit) * 100 : 0;

  return (
    <Tooltip content={`${used} of ${limit} actions used this billing cycle`}>
      <div className="flex items-center gap-3">
        <Zap className="h-4 w-4 text-nexus-500 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <ProgressBar value={used} max={limit} size="sm" />
        </div>
        <span className="text-xs text-surface-400 whitespace-nowrap">
          {pct.toFixed(0)}%
        </span>
      </div>
    </Tooltip>
  );
}
